import React from 'react';

const PianoInline = () => (
  <div key="pianoInline-wrapper" className="pianoInline-wrapper" />
);

export default PianoInline;
